var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-header"},[_c('a-layout-header',[_vm._v(" BI系统 "),_c('a-button',{staticClass:"quitLogin",attrs:{"type":"primary"},on:{"click":_vm.quitLoginClick}},[_vm._v("退出登录")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }